import { Link } from "react-router";
import cn from "~/utils/cn";
import useDesign from "../useDesign";

// Brand mark + wordmark. Story Stack uses the white mark because its page is brand blue. 96px files cover up to 48px at 2x.
export default function Logo({ to = "/", size = 28, wordmark = true, className }: { to?: string; size?: number; wordmark?: boolean; className?: string }) {
  const design = useDesign();
  const src = design === "c" ? "/img/logo/white_bg_transparent_96.png" : "/img/logo/blue_bg_transparent_96.png";
  return (
    <Link to={to} className={cn("inline-flex min-h-11 min-w-11 items-center gap-2 text-ink", className)} aria-label="فونتا">
      <img src={src} alt="" width={size} height={size} className="shrink-0" style={{ width: size, height: size }} />
      {wordmark && <span className="font-display text-xl font-black leading-none">فونتا</span>}
    </Link>
  );
}
